import React from 'react';

const Header = ({ onBackToPlatforms }) => {
  return (
    <header className="sticky top-0 z-50 bg-[#0a0603]/85 backdrop-blur-xl border-b border-orange-500/10">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <button
            onClick={onBackToPlatforms}
            data-testid="back-to-platforms-btn"
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 19l-7-7 7-7" />
            </svg>
            <span className="text-sm">Volver</span>
          </button>

          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-lg bg-[#140c04] border border-orange-500/30 flex items-center justify-center p-1.5">
              <img src="/assets/ocbet/ocbet-emblem.png" alt="OCBET" className="w-full h-full object-contain" />
            </div>
            <span className="text-lg font-bold tracking-wide">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400">OCBET</span>
            </span>
          </div>

          <div className="w-9 h-9 rounded-lg bg-[#140c04] border border-orange-500/20 flex items-center justify-center p-1 opacity-80">
            <img src="/assets/ocbet/ocbet-emblem.png" alt="OCBET" className="w-full h-full object-contain" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
